import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RateInput.scss';

class RateInput extends Component {
  constructor(props) {
    super(props);
    const value = props.value || props.value === 0 ? props.value : '';

    this.state = {
      value,
    };

    this.handleChange = this.handleChange.bind(this);
    this.onAnswerChange = props.onAnswerChange;
  }

  handleChange(event) {
    const { allowDecimals } = this.props;
    const { value } = event.target;
    const re = /^[0-9\b]+(\.)?[0-9\b]?[0-9\b]?$/;
    const reWholeNumberOnly = /^[0-9]+$/;

    if ((allowDecimals && (value === '' || re.test(value)))
    || (!allowDecimals && (value === '' || reWholeNumberOnly.test(value)))) {
      this.setState({ value });
      this.onAnswerChange(value);
    }
  }

  render() {
    const {
      onBlur, onboardingQuestionnaire, minOrMax,
      children, containerClass, inputClass, readOnly,
    } = this.props;
    const { value } = this.state;

    return (
      <div className={`rate-input-container ${containerClass}`}>
        <div>{minOrMax || '' }</div>
        <div className="input-group budget-input d-flex align-items-center">
          { children }
          <input
            id={this.props.id}
            type="number"
            className={`rate-input form-control ${inputClass} ${onboardingQuestionnaire ? 'onboarding-input-edges' : ''}`}
            value={value}
            onChange={this.handleChange}
            onBlur={onBlur}
            placeholder={this.props.placeholder}
            readOnly={readOnly}
          />
        </div>
      </div>
    );
  }
}

RateInput.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onAnswerChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  children: PropTypes.node,
  onboardingQuestionnaire: PropTypes.bool,
  minOrMax: PropTypes.string,
  containerClass: PropTypes.string,
  inputClass: PropTypes.string,
  allowDecimals: PropTypes.bool,
  readOnly: PropTypes.bool,
};

RateInput.defaultProps = {
  value: '',
  placeholder: '',
  onBlur: () => {},
  children: (
    <span className="input-group-addon">$</span>
  ),
  onboardingQuestionnaire: false,
  minOrMax: null,
  containerClass: '',
  inputClass: '',
  allowDecimals: true,
  readOnly: false,
};

export default RateInput;
